module.exports = __webpack_public_path__ + "img/Group 97857.cf21dd7d.png";